var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UploaderState',{attrs:{"text":_vm.MESSAGES.title},scopedSlots:_vm._u([{key:"image",fn:function(){return [_c('img',_vm._b({attrs:{"src":_vm.IMAGE}},'img',_vm.IMAGE_PROPS,false))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }